import type { AnswerValue } from "./answerSet";

export type RubricVersionStatus = "DRAFT" | "PUBLISHED";

export interface Rubric {
    id: number;
    name: string;
    description?: string | null;
    active?: boolean | null;
}

export interface CloneRubricPayload {
    name: string;
    description?: string;
    active?: boolean;
    versionIds?: number[];
}

export interface RubricVersion {
    id: number;
    rubricId: number;
    status: RubricVersionStatus;
    majorVersion: string;
    minorVersion: string;
    codeWorkflows?: Record<string, number[]>;
    layoutConfig?: unknown;
    taskConfiguration?: {
        description?: string | null;
    } | null;
    effectiveDate?: string | null;
    expirationDate?: string | null;
    active?: boolean | null;
    procedureWorkflowId?: number | null;
    modifierWorkflowId?: number | null;
    diagnosisWorkflowId?: number | null;
    caseWorkflowId?: number | null;
}

export type CodeWorkflowType = "PROCEDURE" | "MODIFIER" | "DIAGNOSIS" | "CASE";

export type CodeWorkflowStatus = "DRAFT" | "PUBLISHED";
export interface CloneRubricVersionPayload {
    targetRubricId?: number;
    majorVersion?: string;
    minorVersion?: string;
    status?: RubricVersionStatus;
    layoutConfig?: unknown;
    description?: string;
    effectiveDate?: string;
    expirationDate?: string;
    active?: boolean;
}

export enum WorkflowTriggerAction {
    GO_TO = "GO_TO",
    STOP = "STOP",
    SET_ANSWERS = "SET_ANSWERS",
    AUTOFILL = "AUTOFILL",
}

export interface WorkflowTrigger {
    id?: number;
    fromQuestionId?: number;
    toQuestionId?: number;
    answerValueIds: number[];
    action?: WorkflowTriggerAction;
    conditionRule?: string | null;
    toAnswerValueIds?: number[];
}

export interface WorkflowQuestion {
    id?: number;
    sequenceOrder?: number | null;
    question: Question;
    triggers?: WorkflowTrigger[];
}

export interface CodeWorkflow {
    id?: number;
    name: string;
    codeType: CodeWorkflowType | string;
    description?: string | null;
    active?: boolean | null;
    status?: CodeWorkflowStatus;
    effectiveDate?: string | null;
    expirationDate?: string | null;
    questions?: WorkflowQuestion[];
}

export enum QuestionType {
    MULTIPLE_CHOICE = "MULTIPLE_CHOICE",
    SYSTEM = "SYSTEM",
}

export interface Trait {
    traitType: string;
    traitValue: string;
}

export enum InclusionMode {
    INCLUDE = "INCLUDE",
    EXCLUDE = "EXCLUDE",
}

export interface Question {
    id: number;
    name: string;
    questionText: string;
    questionType: QuestionType;
    required: boolean;
    displayOrder?: number | null;
    active?: boolean | null;
    answerSetId?: number | null;
    answerSetName?: string | null;
    traits?: Trait[];
    toAnswerValueIds?: number[];
    answers?: AnswerValue[];
    selectedAnswerIds?: number[];
    inclusionMode?: InclusionMode;
}

export interface FullRubricWorkflowDetail {
    workflow: CodeWorkflow;
    questions?: WorkflowQuestion[];
}

export interface FullRubricVersion {
    rubric: Rubric;
    version: RubricVersion;
    workflows: FullRubricWorkflowDetail[];
}
